const famtourGrouping = (array: any[]) => {
  const groups: Record<number, { id: number; title: string | null; campaigns: any[] }> = {};
  const ungroupedItems = [];

  for (const item of array) {
    const famtourId = item.fam_tour_id ?? null;

    if (famtourId) {
      if (!groups[famtourId]) {
        groups[famtourId] = {
          id: famtourId,
          title: item.fam_tour_title ?? null,
          campaigns: []
        };
      }
      groups[famtourId].campaigns.push(item);
    } else {
      ungroupedItems.push(item);
    }
  }

  // Combine grouped campaigns and ungrouped items
  const groupedItems = Object.values(groups);
  return [...groupedItems, ...ungroupedItems];
};

export default famtourGrouping;
